import { render, staticRenderFns } from "./short-codes.vue?vue&type=template&id=2c206590"
import script from "./short-codes.vue?vue&type=script&lang=js"
export * from "./short-codes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports